import React from "react";
import './Checkmykyc.scss'
import contactusimg from '../../assets/images/contact-us-img.jpg';

import businessAPI from '../../assets/images/businessAPI.jpg';
import financialCheckAPI from '../../assets/images/financialCheckAPI.webp';
import kYCVerificationAPI from '../../assets/images/kYCVerificationAPI.webp';
import professionCheck from '../../assets/images/professionCheck.jpg';
import vehicleVerification from '../../assets/images/vehicleVerification.jpg';

import verifyIdentity from '../../assets/images/verifyIdentity.webp';
import RapidFace from '../../assets/images/RapidFace.webp';
import MeetCompliance from '../../assets/images/MeetCompliance.webp';

import { Col, Container, Row } from "react-bootstrap";
import Component from './Component';
import { FaCheckCircle } from "react-icons/fa";
import { Link } from "react-router-dom";
function ProfessionCheck() {
  return (
    <>
      <div className="checkmykyc_new">
       <Component/>
        <section class="onboard pt-0">
          <div className="onboard_feature">
            <Container>
              <Row className="align-items-center">
                <Col lg={6} sm={12}>
                  <div class="content">
                    <div class="section-heading">
                      <h2>
                        Verify Identity with Access to 120+ Government IDs and APIs
                      </h2>
                    </div>
                    <p>
                      Government ID verification APIs provide several benefits such
                      as
                    </p>
                    <div className="points">
                      <ul>
                        <li>
                          <div>
                            <FaCheckCircle />
                          </div>
                          <span>
                            Automating the verification process, increasing
                            security.
                          </span>
                        </li>
                        <li>
                          <div>
                            <FaCheckCircle />
                          </div>
                          <span>Reducing fraud and errors.</span>
                        </li>
                        <li>
                          <div>
                            <FaCheckCircle />
                          </div>
                          <span>
                            Providing access to a larger pool of verified
                            identities.
                          </span>
                        </li>
                      </ul>
                      {/* <Link to={"#"} className="btn btn_explore">
                        Learn More
                      </Link> */}
                    </div>
                  </div>
                </Col>
                <Col lg={6} sm={12}>
                  <div class="feature_image">
                    <img class="about-3 m-0" src={verifyIdentity} alt="verifyIdentity" />
                  </div>
                </Col>
              </Row>
            </Container>
          </div>

          <div className="onboard_feature bg_light1">
            <Container>
              <Row className="align-items-center">
                <Col lg={6} sm={12} className="mobile_order2">
                  <div class="feature_image">
                    <img class="about-3 m-0" src={RapidFace} alt="RapidFace" />
                  </div>
                </Col>
                <Col lg={6} sm={12}>
                  <div class="content">
                    <div class="section-heading">
                      <h2>
                        Rapid Face-to-ID Verification with Advanced Face Match Technology
                      </h2>
                    </div>
                    <p>Face match solution .</p>
                    <div className="points">
                      <ul>
                        <li>
                          <div>
                            <FaCheckCircle />
                          </div>
                          <span>
                            Uses computer vision and machine learning algorithms to compare a live capture
                          </span>
                        </li>
                        <li>
                          <div>
                            <FaCheckCircle />
                          </div>
                          <span>
                            Digital image of a person’s face to a reference image, typically a government-issued ID, to verify their identity.
                          </span>   
                        </li>
                        <li>
                          <div>
                            <FaCheckCircle />
                          </div>
                          <span>
                            The solution compares various facial features such as the distance between the eyes, nose, and mouth to determine if it’s a match.
                          </span>
                        </li>
                      </ul>
                      {/* <Link to={"#"} className="btn btn_explore">
                        Learn More
                      </Link> */}
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>

          <div className="onboard_feature">
            <Container>
              <Row className="align-items-center">
                <Col lg={6} sm={12}>
                  <div class="content">
                    <div class="section-heading">
                      <h2>
                        Meet Compliance Requirements with Identity Verification
                      </h2>
                    </div>
                    <p>
                      Identity verification helps comply with regulations by
                      ensuring that.
                    </p>
                    <div className="points">
                      <ul>
                        <li>
                          <div>
                            <FaCheckCircle />
                          </div>
                          <span>
                            Only authorized individuals have access to sensitive
                            information
                          </span>
                        </li>
                        <li>
                          <div>
                            <FaCheckCircle />
                          </div>
                          <span>
                            Providing a clear audit trail of who has accessed that
                            information.
                          </span>
                        </li>
                        <li>
                          <div>
                            <FaCheckCircle />
                          </div>
                          <span>
                            This can help organizations meet compliance requirements
                            related to data privacy and security.
                          </span>
                        </li>
                      </ul>
                      {/* <Link to={"#"} className="btn btn_explore">
                        Learn More
                      </Link> */}
                    </div>
                  </div>
                </Col>
                <Col lg={6} sm={12}>
                  <div class="feature_image">
                    <img class="about-3 m-0" src={MeetCompliance} alt="MeetCompliance" />
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </section>

        <div className="auth-section Benefits">
          <Container>
            <Row>
              <Col md={12}>
                <h2 className="main-title">
                  Digital ID Verification : Industry Use Cases
                </h2>
                <p className="subtitle">
                  Identity verification API is used in across many industries for
                  compliance and fraud prevention
                </p>
              </Col>
              <Col md={12}>
                <div className="features">
                  <Row>

                    <Col md={4} sm={12}>
                      <div className="feature">
                        <div className="content">
                          <h3>
                            <div className="sixFeature">
                              <img src={professionCheck} alt="Profession Check" />
                            </div>
                            Profession Check
                          </h3>
                          <p>
                            Input the Person’s Details, such as name, ID, or contact info, into a profession verification tool.
                          </p>
                        </div>
                      </div>
                    </Col>
                    
                    <Col md={4} sm={12}>
                      <div className="feature">
                        <div className="content">
                          <h3>
                            <div className="sixFeature">
                              <img src={vehicleVerification} alt="Vehicle Verification" />
                            </div>
                            Vehicle Verification
                          </h3>
                          <p>
                            Enter the Vehicle Details, such as the registration number, into a verification portal or app.
                          </p>
                        </div>
                      </div>
                    </Col>

                    <Col md={4} sm={12}>
                      <div className="feature">
                        <div className="content">
                          <h3>
                            <div className="sixFeature">
                              <img src={kYCVerificationAPI} alt="KYC Verification API" />
                            </div>
                            KYC Verification API
                          </h3>
                          <p>
                            The customer is asked to provide personal information such as their full name, address, date of birth, and a government-issued ID (e.g., passport, driver's license).
                          </p>
                        </div>
                      </div>
                    </Col>
                    
                    <Col md={4} sm={12}>
                      <div className="feature">
                        <div className="content">
                          <h3>
                            <div className="sixFeature">
                              <img src={businessAPI} alt="Business API" />
                            </div>
                            Business API
                          </h3>
                          <p>
                            A Business API acts as a digital bridge, connecting different software systems to work together smoothly.
                          </p>
                        </div>
                      </div>
                    </Col>
                    
                    <Col md={4} sm={12}>
                      <div className="feature">
                        <div className="content">
                          <h3>
                            <div className="sixFeature">
                              <img src={financialCheckAPI} alt="Financial Check API" />
                            </div>
                            Financial Check API
                          </h3>
                          <p>
                            Send a Request with customer or company financial data to the API endpoint.
                          </p>
                        </div>
                      </div>
                    </Col>
                    
                  </Row>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
      <div className="contact-form-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">

              <div className="contact-form-img">
                <figure className="image-anime reveal">
                  <img src={contactusimg} alt="contactusimg" />
                </figure>
              </div>

            </div>
            <div className="col-lg-6">
              {/* Section Title Start */}
              <div className="section-title">
                <h3 className="wow fadeInUp">contact us</h3>
                <h2 className="text-anime-style-2" data-cursor="-opaque">
                  Get in Touch <span>with Us</span>
                </h2>
                <p className="wow fadeInUp" data-wow-delay="0.2s">
                  Have questions or need assistance? Reach out to us today! We're
                  here to provide expert solutions and friendly support.
                </p>
              </div>
              {/* Section Title End */}
              <div className="contact-form">
                {/* Contact Form Start */}
                <form
                  id="contactForm"
                  action="#"
                  method="POST"
                  data-toggle="validator"
                  className="wow fadeInUp"
                  data-wow-delay="0.4s"
                >
                  <div className="row">
                    <div className="form-group col-md-6 mb-4">
                      <input
                        type="text"
                        name="fname"
                        className="form-control"
                        id="fname"
                        placeholder="First name"
                        required=""
                      />
                      <div className="help-block with-errors" />
                    </div>
                    <div className="form-group col-md-6 mb-4">
                      <input
                        type="text"
                        name="lname"
                        className="form-control"
                        id="lname"
                        placeholder="Last name"
                        required=""
                      />
                      <div className="help-block with-errors" />
                    </div>
                    <div className="form-group col-md-6 mb-4">
                      <input
                        type="text"
                        name="phone"
                        className="form-control"
                        id="phone"
                        placeholder="Phone no"
                        required=""
                      />
                      <div className="help-block with-errors" />
                    </div>
                    <div className="form-group col-md-6 mb-4">
                      <input
                        type="email"
                        name="email"
                        className="form-control"
                        id="email"
                        placeholder="E-mail address"
                        required=""
                      />
                      <div className="help-block with-errors" />
                    </div>
                    <div className="form-group col-md-12 mb-5">
                      <textarea
                        name="message"
                        className="form-control"
                        id="message"
                        rows={4}
                        placeholder="Message"
                        defaultValue={""}
                      />
                      <div className="help-block with-errors" />
                    </div>
                    <div className="col-md-12">
                      <button type="submit" className="btn-default">
                        send message
                      </button>
                      <div id="msgSubmit" className="h3 hidden" />
                    </div>
                  </div>
                </form>
                {/* Contact Form End */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ProfessionCheck;
